import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";

import DashboardLayout from "../layouts/DashboardLayout/DashboardLayout";
import HomePage from "../pages/HomePage/HomePage";
import AboutUs from "../pages/AboutUs/AboutUs";
import RoomsPage from "../pages/Rooms/RoomsPage";
import RoomRatesPage from "../pages/Rooms/RoomRatesPage";
import Gallery from "../pages/Gallery/Gallery";
import BlogsPage from "../pages/Blogs/BlogsPage";
import BlogDetailsPage from "../pages/Blogs/BlogDetailsPage";
import AdminLoginPage from "../pages/Admin/AdminLoginPage";
import AdminBlogsPage from "../pages/Admin/AdminBlogsPage";
import BlogEditorPage from "../pages/Admin/BlogEditorPage";
import AdminLayout from "../layouts/AdminLayout/AdminLayout";
import AdminProtectedRoute from "./AdminProtectedRoute";
import PaymentSuccess from "../pages/PaymentSuccess/PaymentSuccess";
// import RoomDetailsPage from "../pages/Rooms/RoomDetailsPage/RoomDetailsPage";

import ConfirmationPage from "../pages/Checkout/ConfirmationPage";
import InvoicePage from "../pages/Booking/InvoicePage";
import ContactUs from "../pages/ContactUs/ContactUs";
import WhyChoosePage from "../pages/WhyChoose/WhyChoosePage";
import ExperiencesPage from "../pages/Experiences/ExperiencesPage";
import PrivacyPolicy from "../pages/PrivacyPolicy/PrivacyPolicy";
import TermsConditions from "../pages/TermsConditions/TermsConditions";
import GuestFAQ from "../pages/GuestFAQ/GuestFAQ";

import BookingSuccessPage from "../pages/Booking/BookingSuccessPage";
import CheckoutPage from "../pages/Booking/CheckoutPage";
import MyBookingsPage from "../pages/Booking/MyBookingsPage";
import ProfilePage from "../pages/User/ProfilePage";
import GoogleAdsLanding from "../pages/GoogleAds/GoogleAdsLanding";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function AppRoutes() {
  const location = useLocation();

  return (
    <>
      <ScrollToTop />
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          {/* DashboardLayout contains Navbar & Footer */}
          <Route path="/" element={<DashboardLayout />}>
            <Route index element={<HomePage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="about" element={<AboutUs />} />
            <Route path="rooms" element={<RoomsPage />} />
            <Route path="rates" element={<RoomRatesPage />} />
            <Route path="gallery" element={<Gallery />} />
            <Route path="blogs" element={<BlogsPage />} />
            <Route path="blogs/:slug" element={<BlogDetailsPage />} />
            <Route path="contact" element={<ContactUs />} />
            <Route path="why-choose-us" element={<WhyChoosePage />} />
            <Route path="experiences" element={<ExperiencesPage />} />

            {/* <Route path="checkout" element={<CheckoutPage />} /> */}
            {/* <Route path="invoice/:id" element={<InvoicePage />} /> */}
            <Route path="confirmation" element={<ConfirmationPage />} />
            <Route path="payment-success" element={<PaymentSuccess />} />

            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsConditions />} />
            <Route path="/faq" element={<GuestFAQ />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/booking-success" element={<BookingSuccessPage />} />
            <Route path="/my-bookings" element={<MyBookingsPage />} />
            <Route path="/invoice/:id" element={<InvoicePage />} />

          </Route>

          {/* Standalone Google Ads landing page — no shared layout/nav pages */}
          <Route path="/google-ads" element={<GoogleAdsLanding />} />

          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route element={<AdminProtectedRoute />}>
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminBlogsPage />} />
              <Route path="blogs" element={<AdminBlogsPage />} />
              <Route path="blogs/new" element={<BlogEditorPage />} />
              <Route path="blogs/:id/edit" element={<BlogEditorPage />} />
            </Route>
          </Route>
        </Routes>
      </AnimatePresence>
    </>
  );
}
